import blogsData from './blogsData';

const initialState = {
    blogs: blogsData,
    filters: {
        category: 'All',
        author: 'All',
        query: ''
    }
};

export default initialState;
